/**
 * Pre-compiled fr-FR messages for RichTextInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  bold: `Gras`,
  bulletedList: `Liste à puces`,
  code: `Code`,
  headingFive: `En-tête 5`,
  headingFour: `En-tête 4`,
  headingOne: `En-tête 1`,
  headingThree: `En-tête 3`,
  headingTwo: `En-tête 2`,
  italic: `Italique`,
  listFormatting: `Formatage de la liste`,
  moreFormattingOptions: `Plus d'options de formatage`,
  moreStyles: `Plus de styles`,
  numberedList: `Liste numérotée`,
  paragraph: `Paragraphe`,
  quote: `Citation`,
  redo: `Rétablir`,
  strikethrough: `Barré`,
  subscript: `Indice`,
  superscript: `Exposant`,
  textFormatting: `Formatage du texte`,
  textStyle: `Style de texte`,
  textStyleMenu: `Menu style de texte`,
  underline: `Souligné`,
  undo: `Annuler`,
};
